import React, { Component } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  height: 3.4rem;
  padding: 0 4rem;
  overflow: hidden;
  text-align: center;
  border: 1px solid black;
`

const Text = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`

class Caption extends Component {
  constructor() {
    super()
    this.state = {
      visible: true,
      text: null,
      visibleText: null,
    }
  }

  static getDerivedStateFromProps({ text }, prevState) {
    if (text !== prevState.text) {
      // If text has not been updated before
      if (!prevState.visibleText) {
        return { visible: true, visibleText: text, text }
      } else {
        return { visible: false, visibleText: text, text }
      }
    }
    return null
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.text !== this.state.visibleText ||
      nextState.visible !== this.state.visible
    )
  }

  render() {
    const { visible, text } = this.state
    const { className } = this.props
    return (
      <Wrapper
        className={className}
        style={{
          opacity: visible ? 0.8 : 0,
          transition: 'opacity 0.3s ease-in-out',
        }}
      >
        <Text>{text}</Text>
      </Wrapper>
    )
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  componentDidUpdate() {
    const { visible, visibleText } = this.state
    if (!visible) {
      this.timeout = setTimeout(() => {
        this.setState({ visible: true, text: visibleText })
      }, 200)
    }
  }
}

export default Caption
